module.exports = __webpack_public_path__ + "static/media/051.10f25a48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/051.jpg
// module id = 396
// module chunks = 0